import type {
  ServiceGetByIdResponse,
  ServiceMutationOptionType,
  ServiceQueryOptionType
} from '@/types/service'

import { api, handleAxiosError } from '@/lib/axios'

import type { TProfileResponse } from '../auth/types'
import type {
  MutationResetPasswordValues,
  MutationUpdateProfileValues
} from './validations'

export const PROFILE_QUERY_KEY = (key?: string | Record<string, any>) =>
  ['USER-profile', key] as const

const getById = (): ServiceQueryOptionType<
  ServiceGetByIdResponse<TProfileResponse>
> => ({
  queryKey: PROFILE_QUERY_KEY(),
  queryFn: async () => {
    try {
      const response =
        await api.get<ServiceGetByIdResponse<TProfileResponse>>(`/auth/profile`)
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const update = (): ServiceMutationOptionType<
  ServiceGetByIdResponse<TProfileResponse>,
  MutationUpdateProfileValues
> => ({
  mutationFn: async (data: MutationUpdateProfileValues) => {
    try {
      const response = await api.put<ServiceGetByIdResponse<TProfileResponse>>(
        `/auth/profile`,
        {
          ...data
        }
      )
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const resetPassword = (): ServiceMutationOptionType<
  ServiceGetByIdResponse<TProfileResponse>,
  MutationResetPasswordValues
> => ({
  mutationFn: async (data: MutationResetPasswordValues) => {
    try {
      const response = await api.put<ServiceGetByIdResponse<TProfileResponse>>(
        `/auth/change-password`,
        {
          ...data
        }
      )
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

export const profile = {
  getById,
  update,
  resetPassword
}
